import { z } from 'zod';

/**
 * A card the agent composed with the `render_ui` tool. Only the AG-UI chat receives it, as the
 * `cobrainer.ui` activity; `spec` is the tool arguments as the agent sent them, checked by the
 * generative UI catalog before anything renders.
 */
export const uiBlockSchema = z.object({
    type: z.literal('ui'),
    blockId: z.string(),
    spec: z.unknown(),
});

export type UiBlock = z.infer<typeof uiBlockSchema>;
